import { useAuth } from './hooks/useAuth.js';
import { LoginPage } from './components/LoginPage.js';
import { Dashboard } from './components/Dashboard.js';

/**
 * Auth gating is opt-in. Default = no auth (single-user dashboard).
 * Set `VITE_REQUIRE_AUTH=true` at build time to re-enable the invite-code
 * login flow (which talks to kra-photo-journal-worker /api/auth/*).
 *
 * Pair this with the worker's `ADMIN_AUTH_REQUIRED = "true"` flag in
 * workers/kra-tools/wrangler.toml so both ends agree.
 */
const REQUIRE_AUTH = import.meta.env['VITE_REQUIRE_AUTH'] === 'true';

export function App() {
  const auth = useAuth();

  if (REQUIRE_AUTH && auth.isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg text-muted">
        <span>Loading…</span>
      </div>
    );
  }

  if (REQUIRE_AUTH && !auth.token) {
    return <LoginPage onLogin={auth.login} />;
  }

  return <Dashboard auth={auth} />;
}
